export default __webpack_public_path__ + "media/images/contact_us/hero_img-9f45d705a181bace12b659da9b399db6.jpg";